var _style, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDancefloor2White(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9D9D9D;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 500.8,
    cy: 499.5,
    r: 500
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 55.8388 527.0035)",
    className: "st1",
    cx: 664.1,
    cy: 196.1,
    rx: 82.3,
    ry: 82.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -67.6782 228.8071)",
    className: "st1",
    cx: 242.4,
    cy: 196.1,
    rx: 82.3,
    ry: 82.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M958.7,18.2c-25.5-10.5-54.8,1.7-65.3,27.2l-36.4,88.5L755,294.2l-125.3,25.8c-8.3-0.3-16.4,1.2-23.2,4.8l0,0 l0,0c-3,1.6-5.8,3.6-8.2,6l-119.4,133c-5.5,5.4-9.6,11.9-12.1,19.2l-38.1,109.1c-9.1,26.1,4.7,54.6,30.7,63.7 c5.5,1.9,11,2.8,16.5,2.8c20.7,0,40-12.9,47.2-33.5l34.2-98.1l63.8-62.8L613.5,572l0,0l-87.9,176.6c-1.8,3.3-3.2,6.8-4.3,10.4 l-43.2,151.7c-7.6,26.6,7.8,54.2,34.4,61.8c4.6,1.3,9.2,1.9,13.7,1.9c21.8,0,41.8-14.3,48.1-36.3L616,791.7L704.8,630l73.9,101.3 l15.5,196.9c2.1,26.2,24,46.1,49.8,46.1c1.3,0,2.6-0.1,4-0.2c27.5-2.2,48.1-26.2,45.9-53.8l-16.5-208.8c-0.6-7.8-3-15.3-7.1-22 l-64.2-136.9c5.1-20.1,11-44.1,15.3-63.4c9.3-41.1,14.2-105.5,14.2-105.5l0,0l108.2-199.9c1.6-2.5,2.9-5.1,4.1-7.8L986,83.5 C996.5,57.9,984.3,28.7,958.7,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323.2,564.3l44.3-169.1L469.6,235c8.3-13,9.7-29.1,4-43.3L417,51.8c-9.8-24.3-37.5-36.1-61.8-26.2 c-24.3,9.8-36.1,37.5-26.2,61.8l47.4,117.2l-70.6,110.8l-115.2,12.1l-76.3-74.9l21.7-131c4.3-25.9-13.2-50.3-39.1-54.6 C71,62.7,46.5,80.2,42.2,106.1L16.5,261.4c-0.7,4.1-0.8,8.3-0.4,12.4c-1.3,13.3,2.9,27,12.8,37.4l112.6,130.8L85.4,573.1 c-7.7,14.6-8.8,30.9-4.3,45.5l36.5,311.6c3,25.4,24.5,44.2,49.6,44.2c1.3,0,2.6-0.1,4-0.2c26.8-2.1,47.1-25,46-51.9l-11.5-283.4 L294,762.7c0.2,0.3,0.5,0.7,0.8,1l-28.5,151.3c-5.1,27.1,12.7,53.3,39.9,58.4c3.1,0.6,6.2,0.9,9.3,0.9c23.6,0,44.6-16.7,49.1-40.7 l35.1-186.4c5.2-15.2,4.2-32.5-3.9-47.7L323.2,564.3z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDancefloor2White);
export default __webpack_public_path__ + "static/media/Icon_dancefloor2_white.61bcf979.svg";
export { ForwardRef as ReactComponent };